// Adapted from https://github.com/codegenixdev/react-hook-form-mui-zod-boilerplate
// and YT video https://www.youtube.com/watch?v=JyeWoqWsQFo
// See their repo for a variation that supports an array of objects as options
import { Checkbox, FormControlLabel } from '@mui/material'
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form'

type Props<T extends FieldValues> = {
	name: Path<T>
	label?: string
	disabled?: boolean
}

/**
 * Checkbox component for react-hook-form
 */
export default function RHFCheckbox<T extends FieldValues>({
	name,
	label = '',
	disabled = false,
	...rest
}: Props<T>) {
	const { control } = useFormContext<T>()

	return (
		<FormControlLabel
			control={
				<Controller
					name={name}
					control={control}
					// defaultValue={false}
					render={({ field: { value, ref, ...field } }) => (
						<Checkbox {...field} {...rest} inputRef={ref} disabled={disabled} checked={!!value} />
					)}
				/>
			}
			label={label}
		/>
	)
}
